import React, { useState } from "react";
import { UploadDocument } from "../../Services/API";
import { AuthContext } from "../../Routes/AuthProvider"

const TravelDocument = ({ referenceNo, trackId, userName }) => {
  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [loading, setLoading] = useState(false);

  const handleUploadDocument = async () => {
    try {
      if (!selectedDocumentType || selectedDocumentType.trim() === "") {
        alert("Please select a document type.");
        return;
      }

      if (!selectedFile) {
        alert("Please select a document to upload.");
        return;
      }

      if (!referenceNo) {
        alert("Reference number not found.");
        return;
      }

      const request = {
        ReferenceNo: referenceNo,
        ProductType: "Bus",
        DocumentType: selectedDocumentType,
        Document: selectedFile,
        CreatedBy: userName
      };

      const result = await UploadDocument(request);
      if (result.success) {
        alert(result.message);
        setSelectedDocumentType("");
        setSelectedFile(null);
        //handleGetDocuments();
      } else {
        alert(result.message);
      }
    } catch (err) {
      console.error(err);
      alert("Failed to upload document.");
    }
  };


  return (
    <div className="row">
      <div className="col-md-12">
        <div className="form_row">
          <label className="required">Document Type</label>
          <select
            className="form-control"
            value={selectedDocumentType}
            onChange={(e) => setSelectedDocumentType(e.target.value)}
          >
            <option value="">-- Select Document Type --</option>
            <option value="Approval Email">Approval Email</option>
            <option value="Passport">Passport</option>
            <option value="Payment Information">Payment Information</option>
            <option value="Other">Other</option>
          </select>
        </div>
      </div>

      <div className="col-md-12 mt-3">
        <div className="form_row">
          <label className="required">Select Document</label>
          <input
            type="file"
            className="form-control"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={(e) => setSelectedFile(e.target.files[0])}
          />
          <small className="text-muted">
            Allowed: PDF, JPG, JPEG, PNG (Max 5 MB)
          </small>
        </div>
      </div>

      <div className="col-md-12 text-end mt-3">
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={handleUploadDocument}
            disabled={loading}
          >
            {loading ? "Uploading..." : "Upload Document"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TravelDocument;